import { toast } from "react-toastify";
import { postLoginInstance } from "../../utils";
import { API_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllOccassionData, getAllPlatformData, getAllPlaylistData } from "./AutoshareAction";
import { filterVerifiedItems } from "../../utils/ReusableFunctions";


export const getAllPlatformDataApi = (ctx = null) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    const page = parseInt(params.get("page"), 10) || START_PAGE;

    return postLoginInstance.get(`platform?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size || API_LIMIT}&pageNumber=${page || START_PAGE}`)
      .then((res) => {

        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllPlatformData(res.data.data, ctx?.state.currentPage || START_PAGE));
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  }

};

export const getAllOccassionDataApi = (ctx = null) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    const page = parseInt(params.get("page"), 10) || START_PAGE;

    return postLoginInstance.get(`occassion?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size || API_LIMIT}&pageNumber=${page || START_PAGE}${searchValue && `&searchValue=${searchValue}`}`)
      .then((res) => {



        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllOccassionData(res?.data?.data, ctx?.state.currentPage || START_PAGE));

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  }

};


export const getAllPlaylistDataApi = (ctx = null) => {

  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    return postLoginInstance.get(`playlist?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size || API_LIMIT}&pageNumber=${page || START_PAGE}${searchValue && `&searchValue=${searchValue}`}&isActive=0`)
      .then((res) => {
        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllPlaylistData(res.data.data, ctx?.state.currentPage || START_PAGE));

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  }

};

export const getALLOptionsApi = async (ctx) => {


  let targetedContentOption = await postLoginInstance.get(`targetedContentFilters`)
  targetedContentOption = filterVerifiedItems(targetedContentOption?.data?.data?.list)?.filter(p => !p?.isTargetedContent) || [];

  let objectiveOption = await postLoginInstance.get(`objective`)
  objectiveOption = filterVerifiedItems(objectiveOption?.data?.data?.list)?.map((item) =>
  ({
    label: item.objective,
    value: item.uuid
  })
  ) || [];

  let contentTypeOption = await postLoginInstance.get(`website/contentType/list`)
  contentTypeOption = contentTypeOption?.data?.data?.filter(
    type => type?.isAvailableForCobrand
  )?.map((type) =>
  ({
    label: type.contentTypeName,
    value: type.uuid,
  })
  ) || [];

  let conceptOption = await postLoginInstance.get(`concept`)
  conceptOption = filterVerifiedItems(conceptOption?.data?.data?.list)?.map((item) =>
  ({
    label: item.concept,
    value: item.uuid
  })
  ) || [];


  const options = {
    targetedContentOption,
    objectiveOption,
    contentTypeOption,
    conceptOption
  }
  ctx.setState({
    ...options
  })
}

export const getAllConceptDataApi = (ctx = null, onHide = () => { }) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    return postLoginInstance.get(`concept?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size || API_LIMIT}&pageNumber=${page || START_PAGE}${searchValue && `&searchValue=${searchValue}`}`)
      .then((res) => {
        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllOccassionData(res.data.data, ctx?.state.currentPage || START_PAGE));
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
        onHide();
      })
  }

}
export const getAllObjectiveDataApi = (ctx = null, onHide = () => { }) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    return postLoginInstance.get(`objective?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size || API_LIMIT}&pageNumber=${page || START_PAGE}${searchValue && `&searchValue=${searchValue}`}`)
      .then((res) => {
        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllOccassionData(res.data.data, ctx?.state.currentPage || START_PAGE));
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
        onHide();
      })
  }

}
export const getAllAdAccountApprovalDataApi = (ctx = null, onHide = () => { }) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    return postLoginInstance.get(`adAccountApproval?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size || API_LIMIT}&pageNumber=${page || START_PAGE}${searchValue && `&searchValue=${searchValue}`}`)

      .then((res) => {
        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllOccassionData(res.data.data, ctx?.state.currentPage || START_PAGE));
      }
      )
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
        onHide();
      })
  }

};

export const addObjectiveApi = (data, ctx, onHide, ctx2) => {
  return postLoginInstance.post("objective", data).then((res) => {
    ctx.props.getAllObjectiveDataApi(null, onHide);
    ctx2?.setState({ resLoading: false })
    toast.success("Successfully Save.")
  }).catch((error) => {
    ctx2?.setState({ resLoading: false })
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  })
};
export const updateObjectiveApi = (data, ctx, onHide, id, ctx2) => {

  return postLoginInstance.put(`objective/${id}`, data).then((res) => {
    ctx.props.getAllObjectiveDataApi(null, onHide);
    ctx2?.setState({ resLoading: false })
    toast.success("Successfully Updated.")
  })
    .catch((error) => {
      ctx2?.setState({ resLoading: false })
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
};

export const addConceptApi = (data, ctx, onHide, ctx2) => {
  return postLoginInstance.post("concept", data).then((res) => {
    ctx.props.getAllConceptDataApi(null, onHide);
    ctx2?.setState({ resLoading: false })
    toast.success("Successfully Save.")
  }).catch((error) => {
    ctx2?.setState({ resLoading: false })
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  })
};
export const updateConceptApi = (data, ctx, onHide, id, ctx2) => {

  return postLoginInstance.put(`concept/${id}`, data).then((res) => {
    ctx.props.getAllConceptDataApi(null, onHide);
    ctx2?.setState({ resLoading: false })
    toast.success("Successfully Updated.")
  })
    .catch((error) => {
      ctx2?.setState({ resLoading: false })
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
};








//   export const getAllCitesApi = (ctx) => {
//     return postLoginInstance.get(`website/location/allCities?pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}  ${ctx?.state.locationSearch && `&searchValue=${ctx?.state.locationSearch}`}`)
//       .then((res) => {
//         let option = [];

//         res.data.data.sort().map((item) =>
//           option.push({
//             label: item,
//             value: item
//           }))
//         ctx.setState({
//           allCities: option
//         })
//       }).catch((error)=>{
//         toast.error(error?.response?.data?.message || "Something went wrong")
//       })
//   }
//   export const getAmcApi = (ctx) => {
//     return postLoginInstance.get(`amc`)
//       .then((res) => {
//         let option = [];
//         res.data.data.list.map((item) =>
//           option.push({
//             label: item.amcName,
//             value: item.uuid
//           }))
//         ctx.setState({
//           amcOption: option
//         })
//       }).catch((error)=>{
//         toast.error(error?.response?.data?.message || "Something went wrong")
//       })
//   }
